import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthService} from "../services/auth.service";
import {HttpClient} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private http: HttpClient) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return this.http.get('/rest/isAuth').pipe(
          map(res => {
              // console.log('res:');
              // console.dir(res);

              if (res) {
                  return true;
              } else {
                  this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
                  return false;
              }
          }),
          catchError((err) => {
              return of(false);
          })
      );

      // return this.authService.isAuth();
    // this.authService.isAuth().subscribe(response => {
    //   console.log('response:');
    //   console.dir(response);
    //   if (response !== true) {
    //     this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
    //     return false;
    //   } else {
    //     return true;
    //   }
    //
    // });

    // if (localStorage.getItem('authUser')) {
    ////   logged in so return true
      // return true;
    // }
    //
    //// not logged in so redirect to login page with the return url and return false
    // this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
    // return false;
  }
  
}
